import { FC, MouseEvent } from "react";
import { clearPersistedDocumentRoute } from "@/documents/hooks/usePersistDocumentRoute";
import { useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../ui/breadcrumb";

const ReactBreadcrumb: FC<{ items: { name: string; href?: string }[]; isTruncated?: boolean }> = ({
  items,
  isTruncated = true,
}) => {
  const navigate = useNavigate();

  if (items.length <= 0) {
    return;
  }
  const handleLinkClick = (event: MouseEvent<HTMLAnchorElement>, href?: string) => {
    if (!href) {
      return;
    }

    if (href === "/dashboard/mes-documents") {
      clearPersistedDocumentRoute();
    }

    if (href.startsWith("/")) {
      event.preventDefault();
      navigate(href);
    }
  };

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {items.map((item: { name: string; href?: string }, key: number) =>
          key + 1 == items.length ? (
            <BreadcrumbItem key={key}>
              <BreadcrumbPage className="font-medium text-primary text-sm">
                {item.name.length >= 26 && isTruncated ? item.name.slice(0, 26) : item.name} {item.name.length >= 26 && isTruncated && "..."}
              </BreadcrumbPage>
            </BreadcrumbItem>
          ) : (
            <div key={key} className="inline-flex items-center gap-1.5">
              <BreadcrumbItem>
                <BreadcrumbLink
                  href={item.href}
                  onClick={(event) => handleLinkClick(event, item.href)}
                  className="font-medium text-foreground opacity-70 text-sm"
                >
                  {item.name.length >= 26 && isTruncated ? item.name.slice(0, 26) : item.name} {item.name.length >= 26 && isTruncated && "..."}
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator key={key + "sep"} />
            </div>
          )
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default ReactBreadcrumb;
